import { render } from "./adjust-tags-modal.vue?vue&type=template&id=a185293c"
import script from "./adjust-tags-modal.vue?vue&type=script&lang=js"
export * from "./adjust-tags-modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__